import {
  CLEAR_DELETE_RATING_STATE,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_RATING_ERRORS,
  CLEAR_RATING_STATE,
  DELETE_RATING_FAIL,
  DELETE_RATING_REQUEST,
  DELETE_RATING_SUCCESS,
  GET_ALL_CATEGORY_FAIL,
  GET_ALL_CATEGORY_REQUEST,
  GET_ALL_CATEGORY_SUCCESS,
  GET_ALL_PRODUCTS_FAIL,
  GET_ALL_PRODUCTS_REQUEST,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_PRODUCT_DETAILS_FAIL,
  GET_PRODUCT_DETAILS_REQUEST,
  GET_PRODUCT_DETAILS_SUCCESS,
  GET_PRODUCT_RATING_FAIL,
  GET_PRODUCT_RATING_REQUEST,
  GET_PRODUCT_RATING_SUCCESS,
  GIVE_RATING_FAIL,
  GIVE_RATING_REQUEST,
  GIVE_RATING_SUCCESS,

} from "../constant/productConstant";

export const getAllProductReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_PRODUCTS_REQUEST:
      return {
        loading: true,
        products: {},
      };

    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        loading: false,
        products: action.payload,
      };
    case GET_ALL_PRODUCTS_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_PRODUCT_ERRORS:
      return {
        products: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const getAllCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORY_REQUEST:
      return {
        loading: true,
        categoryList: {},
      };

    case GET_ALL_CATEGORY_SUCCESS:
      return {
        loading: false,
        categoryList: action.payload,
      };
    case GET_ALL_CATEGORY_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_PRODUCT_ERRORS:
      return {
        categoryList: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const getProductDetailReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PRODUCT_DETAILS_REQUEST:
      return {
        loading: true,
        product: {},
      };

    case GET_PRODUCT_DETAILS_SUCCESS:
      return {
        loading: false,
        product: action.payload,
      };
    case GET_PRODUCT_DETAILS_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_PRODUCT_ERRORS:
      return {
        product: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};


export const addNewRatingReducer = (state = {}, action) => {
  switch (action.type) {
    case GIVE_RATING_REQUEST:
      return {
        loading: true,
        ratingData: {},
      };
    case GIVE_RATING_SUCCESS:
      return {
        loading: false,
        ratingData: action.payload,
      };
    case GIVE_RATING_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_PRODUCT_ERRORS:
      return {
        ...state,
        error: null,
      };
    case CLEAR_RATING_STATE:
      return {
        loading: false,
        ratingData: {},
      };

    default:
      return state;
  }
};


export const getProductRatingReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PRODUCT_RATING_REQUEST:
      return {
        loading: true,
        productRating: {},
      };

    case GET_PRODUCT_RATING_SUCCESS:
      return {
        loading: false,
        productRating: action.payload,
      };
    case GET_PRODUCT_RATING_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_RATING_ERRORS:
      return {
        productRating: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};



export const deleteProductRatingReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_RATING_REQUEST:
      return {
        loading: true,
        productRatingDelete: {},
      };
    case DELETE_RATING_SUCCESS:
      return {
        loading: false,
        productRatingDelete: action.payload,
      };
    case DELETE_RATING_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_RATING_ERRORS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CLEAR_DELETE_RATING_STATE:
      return {
        loading: false,
        error: null,
        productRatingDelete: {},
      };

    default:
      return state;
  }
};
